<template>
  <BreadCrumb PageTitle="Shopify Stores" />
  <AddShopify />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import AddShopify from "@/components/Generals/Stores/AddShopify.vue";

export default defineComponent({
  name: "AddShopifyPage",
  components: {
    BreadCrumb,
    AddShopify,
  },
});
</script>